import { FIREBASE_BASE_URL } from "../ducks/consts";

// Acompanha o `publicado/time` da loja, que muda a cada republicação do
// cardápio. Antes era polling de 10s; agora é o streaming do Realtime Database
// pela API REST (Server-Sent Events, sem SDK): o RTDB manda o valor ao conectar
// e de novo a cada mudança.
//
// O stream vai ao firebaseio.com, que algumas redes bloqueiam (ver
// firebase-get-data.js). Enquanto ele não está de pé, o polling antigo assume,
// e o `poll` lê pelo getFirebaseData, que tem o fallback /_dados.

export const POLLING_MS = 10000;
// O RTDB manda `keep-alive` a cada ~30s. Sem nenhum evento neste tempo, a
// conexão é dada como morta (proxy que segura o stream sem fechar, WebView
// que dormiu) e é refeita.
export const SILENCIO_MS = 90000;
// Depois de um erro, o stream volta a ser tentado depois deste tempo, com o
// polling cobrindo o intervalo. Deixar o EventSource reconectar sozinho (a cada
// ~3s) martelaria o firebaseio.com numa rede que o bloqueia.
export const RECONEXAO_MS = 30000;

/**
 * @param {string} namespace a loja
 * @param {{ onTime: (time: number) => void, poll: () => void }} callbacks
 *   `onTime` recebe o valor do stream; `poll` busca o valor por conta própria.
 * @returns {() => void} para tudo
 */
export default function watchPublishedTime(namespace, { onTime, poll }) {
  let fonte = null;
  let polling = null;
  let reconexao = null;
  let ultimoSinal = 0;

  const iniciarPolling = () => {
    if (!polling) polling = setInterval(poll, POLLING_MS);
  };
  const pararPolling = () => {
    clearInterval(polling);
    polling = null;
  };

  const fechar = () => {
    if (!fonte) return;
    fonte.close();
    fonte = null;
  };

  // derruba o stream, cobre com polling e reconecta depois de `ms`
  const recomecar = (ms) => {
    fechar();
    iniciarPolling();
    clearTimeout(reconexao);
    reconexao = setTimeout(conectar, ms);
  };

  const sinal = () => {
    ultimoSinal = Date.now();
    pararPolling();
  };

  function conectar() {
    // o polling cobre até o stream abrir; rede que só descarta os pacotes
    // nem chega a disparar `error`
    iniciarPolling();
    fonte = new EventSource(
      `${FIREBASE_BASE_URL}/${namespace}/publicado/time.json`,
    );
    const atual = fonte;

    atual.onopen = sinal;
    atual.addEventListener("keep-alive", sinal);
    atual.addEventListener("put", (event) => {
      sinal();
      let mensagem;
      try {
        mensagem = JSON.parse(event.data);
      } catch {
        return;
      }
      // `time` é folha: toda escrita nele chega como put na raiz do stream
      if (mensagem && mensagem.path === "/" && mensagem.data != null) {
        onTime(mensagem.data);
      }
    });
    // a regra de leitura mudou e o RTDB encerrou o stream
    atual.addEventListener("cancel", () => recomecar(RECONEXAO_MS));
    atual.addEventListener("auth_revoked", () => recomecar(RECONEXAO_MS));

    atual.onerror = () => {
      if (atual === fonte) recomecar(RECONEXAO_MS);
    };
  }

  if (typeof EventSource === "undefined") {
    iniciarPolling();
    return pararPolling;
  }

  conectar();
  // até o primeiro sinal, conta a partir de agora
  ultimoSinal = Date.now();

  const vigia = setInterval(() => {
    if (fonte && Date.now() - ultimoSinal > SILENCIO_MS) {
      // conectar() já liga o polling até o novo stream abrir
      fechar();
      conectar();
      ultimoSinal = Date.now();
    }
  }, SILENCIO_MS / 3);

  return () => {
    clearInterval(vigia);
    clearTimeout(reconexao);
    pararPolling();
    fechar();
  };
}
